import {
  createDriverMethodCollectingRequest,
  getDriverMethodCollectingRequest,
  getMethodCollectingCatalogRequest,
  updateDriverMethodCollectingRequest,
} from "./driverMethodCollectingApi";

const createErrorMessages = {
  ERROR_METHOD_COLLECTING_INVALID_PAYMENT_VALUE: "La información de cobro debe tener como máximo 255 caracteres.",
  ERROR_METHOD_COLLECTING_DRIVER_NOT_FOUND: "El conductor ya no existe.",
  ERROR_METHOD_COLLECTING_METHOD_NOT_FOUND: "El método de cobro ya no está disponible.",
  ERROR_METHOD_COLLECTING_METHOD_ALREADY_ASSIGNED: "Este conductor ya tiene ese método de cobro registrado.",
};

const updateErrorMessages = {
  ERROR_METHOD_COLLECTING_INVALID_PAYMENT_VALUE: "La información de cobro debe tener como máximo 50 caracteres.",
  ERROR_METHOD_COLLECTING_DRIVER_METHOD_NOT_FOUND: "No se encontró el método de cobro asociado a este conductor.",
  ERROR_METHOD_COLLECTING_INVALID_ID: "El identificador de la asociación no es válido.",
};

export const driverMethodCollectingRepository = {
  async update(data) {
    const fallbackError = "No se pudo actualizar el método de cobro. Inténtalo nuevamente.";
    try {
      const response = await updateDriverMethodCollectingRequest(data);
      if (response.data?.message !== "ok" || !response.data.data) {
        return {
          success: false,
          data: null,
          error: updateErrorMessages[response.data?.code_error] ?? fallbackError,
        };
      }
      return { success: true, data: response.data.data, error: null };
    } catch (error) {
      return {
        success: false,
        data: null,
        error: updateErrorMessages[error.response?.data?.code_error] ?? fallbackError,
      };
    }
  },
  async getCatalog() {
    try {
      const response = await getMethodCollectingCatalogRequest();
      if (response.data?.message !== "ok" || !Array.isArray(response.data.data)) {
        throw new Error("Invalid response");
      }
      return { success: true, data: response.data.data, error: null };
    } catch (error) {
      return {
        success: false,
        data: [],
        error: "No se pudieron cargar las opciones de cobro. Inténtalo nuevamente.",
      };
    }
  },
  async create(data) {
    try {
      const response = await createDriverMethodCollectingRequest(data);
      if (response.data?.message !== "ok" || !response.data.data) {
        return {
          success: false,
          data: null,
          error: createErrorMessages[response.data?.code_error] ?? "No se pudo guardar el método de cobro. Inténtalo nuevamente.",
        };
      }
      return { success: true, data: response.data.data, error: null };
    } catch (error) {
      return {
        success: false,
        data: null,
        error: createErrorMessages[error.response?.data?.code_error] ?? "No se pudo guardar el método de cobro. Inténtalo nuevamente.",
      };
    }
  },
  async getByDriverId(driverId) {
    try {
      const response = await getDriverMethodCollectingRequest(driverId);
      if (response.data?.message !== "ok" || !Array.isArray(response.data.data)) {
        throw new Error("Invalid response");
      }
      return { success: true, data: response.data.data, error: null };
    } catch (error) {
      return {
        success: false,
        data: [],
        error: "No se pudieron cargar los métodos de cobro. Inténtalo nuevamente.",
      };
    }
  },
};
